import {FlattenedMeterFrameHistoricalDto} from '@shared/interfaces/dto/FlattenedMeterFrameHistoricalDto';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import {TableConfig} from '@shared/interfaces/table/table-config';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';
import {DATE_TIME_FORMAT} from '@app/core/constants/date-time-format';

export const meterframeHistoryTable: TableConfig<FlattenedMeterFrameHistoricalDto> = {
  selectable: true,
  columns: [
    {
      title: 'meterFrame.history.index',
      key: 'index'
    },
    {
      title: 'meterFrame.history.date',
      key: 'date',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT,
      }
    },
    {
      title: 'meterFrame.history.action',
      key: 'meterFrameAction',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notspecified: 'historicalAction.notSpecified',
        remove: 'historicalAction.remove',
        update: 'historicalAction.update',
        create: 'historicalAction.create',
        disconnect: 'historicalAction.disconnect',
        connect: 'historicalAction.connect'
      }
    },
    {
      title: 'meterFrame.identification',
      key: 'identification'
    },
    {
      title: 'meterFrame.history.meterAction',
      key: 'meterAction',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        null: '',
        notspecified: 'historicalAction.notSpecified',
        remove: 'historicalAction.remove',
        update: 'historicalAction.update',
        create: 'historicalAction.create',
        disconnect: 'historicalAction.disconnect',
        connect: 'historicalAction.connect'
      }
    },
    {
      title: 'meter.meterNumber',
      key: 'meterNumber'
    },
    {
      title: 'meterFrame.history.user',
      key: 'changeBy'
    }
  ],
}
